/**
 *
 * @module telemetryPayload
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../../exception/invalidArgumentException';

const {
    object
} = Check.assert;

/**
 *
 * @class TelemetryPayload
 * @desc Model containing the information to report to the telemetry service.
 *
 */
export default class TelemetryPayload {

    /**
     *
     * @param {Object} [server={}]
     * @param {Object} [client={}]
     *
     */
    constructor(server = {}, client = {}) {

        const errorMessage = {
            ctor: 'StreamSampleEvent(server, client)',
            get server() {
                return `${this.ctor} needs a server data Object`;
            },
            get client() {
                return `${this.ctor} needs a client data Object`;
            }
        };

        object(server, errorMessage.server, InvalidArgumentException);
        object(client, errorMessage.client, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Object}
         * @desc Dictionary containing server provided tracking information.
         *
         */
        this.server = server;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Dictionary containing client provided tracking information.
         *
         */
        this.client = client;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/telemetryPayload.js